import {AlertInfo} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import React from 'react';

const {earlyAccessDescriptionHealth} = translations['pt-br'].privateFlow.guideFlow;

export function EarlyAccessAlert() {
	return <AlertInfo.Root sx={{borderRadius: 0}}>{earlyAccessDescriptionHealth}</AlertInfo.Root>;
}
